import { useModules } from "src/api/modulesApi";
import { ModuleKind } from "src/clients/flow-api";

/**
 * Query-based wizard-module check. Uses the same query key as
 * `WorkspaceRoutesContext`, so under workspace routes it resolves from the
 * React Query cache without an extra request — while staying usable in
 * components that are not guaranteed to sit below the workspace outlet
 * context (unlike `useIsModuleEnabled`).
 */
export const useWorkspaceHasWizardModule = (
  workspaceId: string | undefined,
): { isEnabled: boolean } => {
  const { data: modules } = useModules({
    workspaceId,
    enabled: Boolean(workspaceId),
  });

  return {
    isEnabled:
      modules?.some(
        (module) =>
          module.kind === ModuleKind.WIZARD && Boolean(module.spec?.is_active),
      ) ?? false,
  };
};
